export const DATA_HOOKS = {
  OVERLAY: 'drawer-overlay',
  CONTENT: 'drawer-content',
  HANDLE: 'drawer-handle',
  CONTENT_WRAPPER: 'drawer-content-wrapper',
};

export const CONTENT_DRAG_THRESHOLD_PX = 10;
